import ProofOfDelivery from './ProofOfDelivery';

export default ProofOfDelivery;
